export enum UserRole {
  All = 'All',
  Admin = 'Super Admin',
  Medico = 'Medico',
  Responsable_Farmacia = 'Responsable Farmacia',
  Paciente = 'Paciente',
  Empleado_Farmacia = 'Empleado Farmacia',
  Supervisor_Sucursales = 'Supervisor Sucursales',
  Particular = 'Particular',
}
